import { defineComponent as T, ref as y, computed as _, watch as V, onMounted as z, openBlock as u, createElementBlock as d, normalizeClass as k, createElementVNode as r, createVNode as g, unref as v, createCommentVNode as p, Fragment as F, renderList as A, createBlock as O, resolveDynamicComponent as M, withCtx as E, createTextVNode as G, toDisplayString as b, withDirectives as W, vModelText as R } from "vue";
import { FirstPageIcon as S, ChevronLeftIcon as U, ChevronRightIcon as j, LastPageIcon as q } from "@frontiers/brink-icons";
import './assets/index14.css';const H = { class: "Pagination__wrapper" }, J = { class: "Pagination__mainActions" }, K = ["disabled"], Q = ["disabled"], X = { key: 0 }, Y = {
  key: 1,
  class: "Pagination__byInput"
}, Z = ["max", "disabled"], ee = { class: "Pagination__counter" }, te = { class: "Pagination__mainActions" }, ae = ["disabled"], ne = { key: 0 }, se = ["disabled"], oe = { class: "Pagination__footer" }, ue = /* @__PURE__ */ T({
  __name: "Pagination",
  props: {
    totalItems: {},
    skin: { default: "buttons" },
    itemsPerPage: { default: 5 },
    showFirstLastButtons: { type: Boolean, default: !0 },
    showButtonText: { type: Boolean, default: !0 },
    label: { default: "Items" },
    pageNumber: { default: 1 },
    isDisabled: { type: Boolean, default: !1 }
  },
  emits: ["new-page"],
  setup(w, { emit: f }) {
    const a = w, t = y(-1), h = y(1920), l = _(() => Math.ceil(a.totalItems / a.itemsPerPage)), C = _(() => {
      let e, n;
      return t.value === l.value ? l.value === 1 ? (n = 1, e = a.totalItems, `${n}-${e} of ${a.totalItems} ${a.label}`) : (n = a.itemsPerPage * (t.value - 1), e = a.totalItems, `${n}-${e} of ${a.totalItems} ${a.label}`) : (e = a.itemsPerPage * t.value, n = e - a.itemsPerPage + 1, `${n}-${e} of ${a.totalItems} ${a.label}`);
    }), I = (e) => e === "..." ? "div" : "button", $ = _(() => {
      const e = l.value, n = t.value, s = h.value < 768 ? 3 : 5, c = 2;
      if (e <= s)
        return Array(e).fill(0).map((o, i) => i + 1);
      {
        const o = [];
        if (n <= s - c) {
          for (let i = 1; i <= s; i++)
            o.push(i);
          o.push("..."), o.push(e);
        } else if (n >= e - c) {
          o.push(1), o.push("...");
          for (let i = e - s + c - 1; i <= e; i++)
            o.push(i);
        } else {
          o.push(1), o.push("...");
          for (let i = n - 1; i <= n + 1; i++)
            o.push(i);
          o.push("..."), o.push(e);
        }
        return o;
      }
    }), B = _(() => l.value === 1), x = () => {
      t.value != l.value && !a.isDisabled && (t.value++, P(t.value));
    }, N = () => {
      t.value != 1 && !a.isDisabled && (t.value--, P(t.value));
    }, m = (e) => {
      t.value > 0 && t.value < a.totalItems && !a.isDisabled && (t.value = e, P(t.value));
    }, D = (e) => {
      e !== "..." && typeof e != "string" && m(e);
    }, P = (e) => {
      f("new-page", e);
    }, L = () => {
      f("new-page", t.value);
    };
    return V(
      () => a.pageNumber,
      () => {
        t.value = a.pageNumber;
      }
    ), z(() => {
      t.value = a.pageNumber, h.value = window.innerWidth;
    }), (e, n) => (u(), d("div", {
      class: k(["Pagination", { "Pagination--disabled": e.isDisabled }])
    }, [
      r("div", H, [
        r("div", J, [
          e.showFirstLastButtons ? (u(), d("button", {
            key: 0,
            "aria-label": "Go to first page",
            onClick: n[0] || (n[0] = (s) => m(1)),
            class: "Pagination__btn Pagination__btn--first",
            disabled: t.value <= 1
          }, [
            g(v(S), { size: "md" })
          ], 8, K)) : p("", !0),
          r("button", {
            "aria-label": "Previous page",
            onClick: N,
            class: "Pagination__btn Pagination__btn--prev",
            disabled: t.value === 1
          }, [
            g(v(U), { size: "md" }),
            e.showButtonText ? (u(), d("span", X, "Previous")) : p("", !0)
          ], 8, Q)
        ]),
        e.skin === "buttons" ? (u(!0), d(F, { key: 0 }, A($.value, (s) => (u(), O(M(I(s)), {
          key: s,
          onClick: (c) => D(s),
          class: k([
            "Pagination__btnPage",
            { "Pagination__btnPage--isActive": s === t.value }
          ])
        }, {
          default: E(() => [
            G(b(s), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "class"]))), 128)) : (u(), d("div", Y, [
          W(r("input", {
            "onUpdate:modelValue": n[1] || (n[1] = (s) => t.value = s),
            class: "Pagination__input",
            type: "number",
            min: "1",
            max: l.value,
            disabled: B.value,
            onChange: L
          }, null, 40, Z), [
            [R, t.value]
          ]),
          r("p", ee, "of " + b(l.value), 1)
        ])),
        r("div", te, [
          r("button", {
            "aria-label": "Next page",
            onClick: x,
            class: "Pagination__btn Pagination__btn--next",
            disabled: t.value === l.value
          }, [
            e.showButtonText ? (u(), d("span", ne, "Next")) : p("", !0),
            g(v(j), { size: "md" })
          ], 8, ae),
          e.showFirstLastButtons ? (u(), d("button", {
            key: 0,
            "aria-label": "Go to last page",
            onClick: n[2] || (n[2] = (s) => m(l.value)),
            class: "Pagination__btn Pagination__btn--last",
            disabled: t.value === l.value
          }, [
            g(v(q), { size: "md" })
          ], 8, se)) : p("", !0)
        ])
      ]),
      r("div", oe, b(C.value), 1)
    ], 2));
  }
});
export {
  ue as Pagination
};
